import { render, staticRenderFns } from "./flatpickr.vue?vue&type=template&id=788ec25a"
import script from "./flatpickr.vue?vue&type=script&lang=js"
export * from "./flatpickr.vue?vue&type=script&lang=js"
import style0 from "./flatpickr.vue?vue&type=style&index=0&id=788ec25a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports